import {
  Box,
  Card,
  CardContent,
  Grid,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import React from "react";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
export default function ExpenseItemCard({ item, onClick ,width}) {
  console.log("item ", item);
  return (
    <Card
      sx={{
        cursor: "pointer",
        backgroundColor: "#EEEEFF",
        transition: "0.3s",
        "&:hover": {
          boxShadow: "0px 4px 12px rgba(0,0,0,0.2)",
        },
      }}
      onClick={() => onClick(item)}
    >
      <CardContent
        sx={{
          px: 2,
          py: 1,
          boxShadow: "0px 4px 4px 0px #00000033",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row", // Always horizontal
            // justifyContent: "space-between",
            gap:3,
            alignItems: "center",
            flexWrap: "nowrap",
          }}
        >
          {/* Label */}
          <Typography
            sx={{
               fontSize: { xs: "12px", sm: "13px", md: "15px" },
              fontWeight: 500,
              color: "black",
              whiteSpace: "nowrap",
            }}
          >
            Category Name
          </Typography>

          {/* Value */}
          <Typography
            color="primary"
            sx={{
               fontSize: { xs: "12px", sm: "13px", md: "15px" },
              fontWeight: 600,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              maxWidth: "60%",
              textAlign: "left",
            }}
          >
            {width ? item?.name : item?.category}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
}
